module.exports = __webpack_public_path__ + "img/cash.b457fae8.png";